import React from "react";
import { Messages } from "../../../../../../types/messages";
import DetachedModal from "../../../../../Shared/Modals/DetachedModal/DetachedModal";

type ViewSmsModalType = {
  message: Messages;
  handleClose: () => void;
};

const ViewSmsModal = ({ message, handleClose }: ViewSmsModalType) => {
  const sentDate = new Date(message.created_date).toLocaleDateString(
    window.locale,
    {
      hour: "2-digit",
      minute: "2-digit"
    }
  );

  return (
    <DetachedModal heading="SMS Details" width="70%" handleClose={handleClose}>
      <div className="ViewSmsModalDetails pt-[calc(var(--panelPadding)*2)] flex flex-col flex-1">
        <div className="ViewSmsModal-Sent flex justify-between">
          <div>Sent: {sentDate.split(",").join("")}</div>
          <div>Status: {message.status ?? message.action}</div>
        </div>
        <div className="ViewSmsModal-Recipient pt-panel-padding flex justify-between">
          <div>From: {message.from}</div>
          <div>
            To: {Array.isArray(message.to) ? message.to.join(", ") : message.to}
          </div>
        </div>
        <div className="ViewSmsModal-MessageContainer pt-[calc(var(--panelPadding)*2)] flex-[1_100%] flex flex-col">
          Message:
          <div className="ViewSmsModal-Message overflow-auto flex-grow">
            {message.body}
          </div>
        </div>
      </div>
    </DetachedModal>
  );
};

export default React.memo<ViewSmsModalType>(ViewSmsModal);
